import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroChecklistPipe } from '../pipes/filtro-checklist.pipe';
import { ActivatedRoute, Router } from "@angular/router";

import { CheckMilimetragemService } from '../services/check-milimetragem.service';
import { EmbarqueEquipeService } from '../services/embarque-equipe.service';
import { VeiculoService } from '../services/veiculo.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ExcelService } from '../services/excel.service';
import { AuthService } from '../services/auth.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { ProfissionalService } from '../services/profissional.service';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';

@Component({
  selector: 'app-embarque-equipe',
  templateUrl: './embarque-equipe.component.html',
  styleUrls: ['./embarque-equipe.component.css'],
  animations: [loadingFade, modal, alert]
})
export class EmbarqueEquipeComponent implements OnInit {
  public loading = false;
  public checklists = [];
  public veiculos = [];
  public unidades = [];
  public clientes = [];
  public profissionais = [];
  public periodos = [{ periodo: 'D', periodo_nome: 'Diurno' }, { periodo: 'N', periodo_nome: 'Noturno' }];
  public situacoes = [{ situacao: '1', situacao_nome: 'Ativo' }, { situacao: '0', situacao_nome: 'Inativo' }];
  public perfil = this.authSvc.getPerfil();

  public formFiltro: FormGroup;

  //Id do menu da tb_menu
  public menu_id = 113; //Embarque de equipe

  // paginacao
  public page = 1;
  public limit = 10;
  public count = 0;


  // filtro
  public filtro = [];
  public dadosFiltrados = [];
  public showFilter = true;

  	//acesso
	public usuario_perfil;
	public visualizar = true;
	public editar = false;
  public usuario_exibir_regiao;

  constructor(
    private fb: FormBuilder,
    private checkMilimetragemSvc: CheckMilimetragemService,
    private clienteSvc: ClienteService,
    private unidadeSvc: UnidadeService,
    private veiculoSvc: VeiculoService,
    private authSvc: AuthService,
    private router: Router,	
    private route: ActivatedRoute,
    private embarqueEquipeSvc: EmbarqueEquipeService,
    private excelSvc: ExcelService,
    private profissionalSvc: ProfissionalService ,
    private perfilUsuarioSvc: PerfilUsuarioService 
  ) { }

  ngOnInit() {
		
    //Verifica Permissões Acesso
    this.usuario_perfil = this.authSvc.getPerfil();
    this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
      if(data[0].editar){
        this.editar = true;
      }
    }).catch((err) => {
      console.log(err);
    });  

    //Verifica perfil de Acesso
    this.getConsultaPorRegiaoOuUsuario();    

    this.criaFiltro();
  }

  getPermissoesAcesso(){

    this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
			
      if(data[0].editar){
        this.editar = true;
      }

    }).catch((err) => {
      console.log(err);
    });  

  }

  criaFiltro() {
    this.pegaClientes();
    this.pegaUnidades();
    //this.pegaVeiculos();

    this.formFiltro = this.fb.group({
      cliente_id___cliente: null,
      unidade_id___unidade: null,
      veiculo_id___veiculo: null,
      embarque_equipe_turno___periodo: null,
      embarque_equipe_status___status: null,
      embarque_equipe_data___data_i: null,
      embarque_equipe_data___data_f: null,
      profissional_id___profissional: null
    });

    let campos_data = ['embarque_equipe_data___data_i', 'embarque_equipe_data___data_f'];
    moment.locale('pt-Br');
    for (let campo of campos_data) {
      Datepicker('#' + campo, {
        customMonths: moment.months(),
        customDays: moment.weekdaysShort(),
        overlayPlaceholder: 'Preencha o ano',
        overlayButton: 'Enviar',
        formatter: (element, date) => {
          let formatted = moment(date).format('DD/MM/YYYY');
          this.formFiltro.controls[campo].setValue(formatted);
        }
      });
    }


    this.route.params.subscribe( params => {

      if(params.id){

        let splitF = params.id.split("&");

        let loCliente_id = null;
        let loUnidade_id = null;
        let loVeiculo_id = null;
        let loTipoVeiculo_id = null;
        let loPeriodo_id = null;
        let loData_i = "";
        let loData_f = "";
        let loProfissional_id = null;

        //this.showFilter = false;

        for (var i = 0; i < splitF.length; i++) {

          var loSplitValor = splitF[i].split("=");

          switch(loSplitValor[0]) { 
            case "cliente_id___cliente": { 

              if(loSplitValor[1] !== "null"){
                this.showFilter = false;
                loCliente_id = parseInt(loSplitValor[1]);
                this.pegaUnidadesFiltro(loSplitValor[1]);
              }
               break; 

            } 
            case "unidade_id___unidade": { 
              if(loSplitValor[1] !== "null"){
                this.showFilter = false;
                loUnidade_id = parseInt(loSplitValor[1]);
                this.pegaVeiculosEProfissionalFiltro(loUnidade_id,loCliente_id);
              }

              break; 
            }
            case "veiculo_id___veiculo": { 
              if(loSplitValor[1] !== "null"){
                this.showFilter = false;
                   loVeiculo_id = parseInt(loSplitValor[1]);
              }
               break; 
            } 
            case "embarque_equipe_turno___periodo": { 
              if(loSplitValor[1] !== "null"){
                this.showFilter = false;
                loPeriodo_id = loSplitValor[1];
              }
              break; 
            }  
            case "embarque_equipe_data___data_i": { 
              if(loSplitValor[1] !== "null"){
                this.showFilter = false;
                let splitDate1 = loSplitValor[1].split("-");
                if(splitDate1){
                  loData_i = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
                }
              }
               break; 
            }      
            case "embarque_equipe_data___data_f": { 
              if(loSplitValor[1] !== "null"){
                this.showFilter = false;
                let splitDate1 = loSplitValor[1].split("-");
                if(splitDate1){
                  loData_f = splitDate1[2] + "/" + splitDate1[1] + "/" + splitDate1[0];
                }
              }
               break; 
            }      
            case "profissional_id___profissional": { 
              if(loSplitValor[1] !== "null"){
                this.showFilter = false;
                   loProfissional_id =  parseInt(loSplitValor[1]);
              }
               break; 
            }                                                      
           }

        }
        this.preencheForm({
          cliente_id___cliente: loCliente_id,
          unidade_id___unidade: loUnidade_id,
          veiculo_id___veiculo: loVeiculo_id,
          embarque_equipe_turno___periodo: loPeriodo_id,
          embarque_equipe_status___status: null, // nao esta sendo usado?
          embarque_equipe_data___data_i: loData_i,
          embarque_equipe_data___data_f: loData_f,
          profissional_id___profissional: loProfissional_id									

        });
        this.filtra();

      }

    });

  }

  preencheForm(dados) {
    this.formFiltro.setValue(dados);
    }

  pegaUnidadesFiltro(cliente_id){
    if(cliente_id){
      this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), cliente_id).then((data: any) => {
        this.unidades = data;
        this.loading = false;
      }).catch((err) => {
        console.log(err);
        this.loading = false;
      });
    }
  }

  pegaVeiculosEProfissionalFiltro(unidade_id,cliente_id){

    if(typeof unidade_id === 'undefined'){
      return "";
    }else{
    this.loading = true;
      this.veiculos = []
      this.veiculoSvc.getByVeiculoUnidadeEspecialidade(unidade_id,"ambulancia").then((data: any[]) => {
  
      let dados = [];
      for(let veiculo of data){
        dados.push({
        veiculo_id: veiculo.veiculo_id,
        placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
        unidade_id: unidade_id,
        cliente_id: cliente_id
        });
      }
  
      this.veiculos = dados;
      this.pegaProfissionaisClienteUnidadeFiltro(cliente_id,unidade_id)
  
      this.loading = false;
      }).catch((err) => {
      console.log(err);
      });
    }
  }

  pegaProfissionaisClienteUnidadeFiltro(cliente_id,unidade_id){
    this.loading = true;
    
    this.profissionalSvc.getProfissionalEdit(cliente_id,unidade_id).then((data: any[]) => {
        this.profissionais = data;
  
      this.loading = false;
      }).catch((err) => {
        console.log(err);
      });
    }

  pegaChecklists() {

    this.checklists = [];
    this.loading = true;

    this.embarqueEquipeSvc.getEmbarqueEquipesByUsuarioQtde(this.authSvc.getUsuarioId(), this.filtro).then((qtde: any) => {
      this.count = qtde;

      this.embarqueEquipeSvc.getEmbarqueEquipesByUsuario(this.authSvc.getUsuarioId(), this.filtro, this.page).then((data: any) => {
        this.checklists = data;
				this.loading = false;
			}).catch((err) => {
				this.loading = false;
				console.log(err);
			});

    }).catch((err) => {
      this.loading = false;
      console.log(err);
    });
  }


  pegaChecklistsRegiao() {

    this.checklists = [];
    this.loading = true;

    this.embarqueEquipeSvc.getEmbarqueEquipesByRegiaoQtde(this.authSvc.getUsuarioId(), this.filtro).then((qtde: any) => {
      this.count = qtde;

      this.embarqueEquipeSvc.getEmbarqueEquipesByRegiao(this.authSvc.getUsuarioId(), this.filtro, this.page).then((data: any) => {
        this.checklists = data;
				this.loading = false;
			}).catch((err) => {
				this.loading = false;
				console.log(err);
			});

    }).catch((err) => {
      this.loading = false;
      console.log(err);
    });
  }


  pegaClientes() {
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.clientes = data;
    });
  }

  pegaUnidades() {
    this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeCliente(evento) {
    this.formFiltro.controls.unidade_id___unidade.setValue(null);
    this.formFiltro.controls.veiculo_id___veiculo.setValue(null);
    this.formFiltro.controls.profissional_id___profissional.setValue(null);

    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeVeiculoUnidade(e){

    if(typeof e === 'undefined'){
			return "";
		}else{
      this.loading = true;
      this.veiculos = []
      this.veiculoSvc.getByVeiculoClienteUnidadeEspecialidade(e.cliente_id,e.unidade_id,e.cliente_id).then((data: any[]) => {
  
          let dados = [];
          for(let veiculo of data){
            dados.push({
              veiculo_id: veiculo.veiculo_id,
              placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
              unidade_id: e.unidade_id,
              cliente_id: e.cliente_id
            });
          }
  
          this.veiculos = dados;
  
          this.pegaProfissionaisClienteUnidade(e);
  
          this.loading = false;
        }).catch((err) => {
          console.log(err);
        });
        
    }

	}

  
 

  pegaVeiculos() {
    this.veiculoSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.veiculos = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  primPagina() {
    this.page = 1;
    this.getConsultaPorRegiaoOuUsuario();
  }

  paginaAnt() {
    this.page = Math.max(this.page - 1, 1);
    this.getConsultaPorRegiaoOuUsuario();
  }

  proxPagina() {
    this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
    this.getConsultaPorRegiaoOuUsuario();
  }

  ultPagina() {
    this.page = Math.ceil(this.count / this.limit);
    this.getConsultaPorRegiaoOuUsuario();
  }

  filtra() {
    this.filtro = this.formFiltro.value;
    this.dadosFiltrados = new FiltroChecklistPipe().transform(this.checklists, this.filtro);
    this.count = this.dadosFiltrados.length;
    this.page = 1;
    this.getConsultaPorRegiaoOuUsuario();
  }

  apagaChecklist(id) {
    Swal.fire({
      type: 'warning',
      title: 'Deseja realmente apagar este registro?',
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Apagar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33'

    }).then((result) => {
      if (result.value == true) {
        if (this.authSvc.getPerfil() == 2) {
          this.embarqueEquipeSvc.apagaEmbarqueEquipeAdmin(id).then((data) => {
            this.getConsultaPorRegiaoOuUsuario();
            Swal.fire({
              type: 'success',
              title: 'Apagado com sucesso!'
            });
          }).catch((err) => {
            console.log(err);
            Swal.fire({
              type: 'error',
              title: 'Ops! Algo de errado aconteceu!',
              text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
            });
          });
        }
        else {
          this.embarqueEquipeSvc.apagaEmbarqueEquipe(id).then((data) => {
            this.getConsultaPorRegiaoOuUsuario();
            Swal.fire({
              type: 'success',
              title: 'Apagado com sucesso!'
            });
          }).catch((err) => {
            console.log(err);
            Swal.fire({
              type: 'error',
              title: 'Ops! Algo de errado aconteceu!',
              text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
            });
          });
        }
      }
    })
  }

  exportarExcel() {
    
   
		this.perfilUsuarioSvc.getByUsuarioPerfil(this.usuario_perfil).then((data: any) => {
			
			this.usuario_exibir_regiao = data.usuario_exibir_regiao
			if(this.usuario_exibir_regiao == "A"){
				this.exportarExcelRegiao();
			}else{
				this.exportarExcelUsuario();
			}

		}).catch((err) => {
			console.log(err);scrollBy
		});  


  }


  exportarExcelUsuario(){

    console.log("[exportarExcelUsuario]")

    let data = [];
		//let ultimoId = -1;
		let index = 0;
		
		let localFunction = (ultimoId) => {
			//this.loading = true;
			this.embarqueEquipeSvc.getEmbarqueEquipesByExcel(this.authSvc.getUsuarioId(), this.filtro, ultimoId).then((res:any) => {
				if (res.length > 0) {
					let ultimoId = 0;

          //console.log("[res]= ", res);

					for(let i in res) {
						let row = res[i];

						data[index] = {
              'Data do Turno': moment(row.embarque_equipe_data).format('DD/MM/YYYY'),
              'Central': row.cliente_nome,
							'Unidade': row.unidade_nome,						
							'Periodo': row.check_ambulancia_turno == 'D' ? 'Diurno' : 'Noturno',
							'Veículo': row.veiculo.veiculo_placa,
							'Profissional': row.profissional.profissional_nome,
              'Tipo Profissional': row.tipo_profissional_nome,
							'Inicio do turno': row.embarque_equipe_registro? moment(row.embarque_equipe_registro).format('DD/MM/YYYY HH:mm:ss') : '',
              'Fim do turno': row.embarque_equipe_fim_turno? moment(row.embarque_equipe_fim_turno).format('DD/MM/YYYY HH:mm:ss') : '',
						};

						++index;
						ultimoId = row.embarque_equipe_id;
					}

					localFunction(ultimoId);
				}
				else {
					this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Embarque equipe');
					this.loading = false;
				}
			});
		};

		localFunction(-1);     
    
    
    /*if (this.dadosFiltrados.length == 0) {
      this.dadosFiltrados = this.checklists;
    }

    for (let index in this.dadosFiltrados) {
      data[index] = {
        'Data do Turno': moment(this.dadosFiltrados[index].embarque_equipe_data).format('DD/MM/YYYY'),
        'Central': this.dadosFiltrados[index].cliente.cliente_nome,
        'Unidade': this.dadosFiltrados[index].unidade.unidade_nome,
        'Periodo': this.dadosFiltrados[index].embarque_equipe_turno == 'D' ? 'Diurno' : 'Noturno',
        'Veículo': this.dadosFiltrados[index].veiculo.veiculo_placa,
        'Profissional': this.dadosFiltrados[index].profissional.profissional_nome,
        'Inicio do turno': moment(this.dadosFiltrados[index].embarque_equipe_registro).format('DD/MM/YYYY HH:mm:ss'),
        'Fim do turno': moment(this.dadosFiltrados[index].embarque_equipe_fim_turno).format('DD/MM/YYYY HH:mm:ss'),
      };
    }
    this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Checklists');*/

  }



  exportarExcelRegiao(){

    console.log("[exportarExcelRegiao]")
    
    let data = [];
		//let ultimoId = -1;
		let index = 0;
		
		let localFunction = (ultimoId) => {
			//this.loading = true;
			this.embarqueEquipeSvc.getEmbarqueEquipesByExcelRegiao(this.authSvc.getUsuarioId(), this.filtro, ultimoId).then((res:any) => {
				if (res.length > 0) {
					let ultimoId = 0;

          //console.log("[res]= ", res);

					for(let i in res) {
						let row = res[i];

						data[index] = {
              'Data do Turno': moment(row.embarque_equipe_data).format('DD/MM/YYYY'),
              'Central': row.cliente_nome,
							'Unidade': row.unidade_nome,						
							'Periodo': row.check_ambulancia_turno == 'D' ? 'Diurno' : 'Noturno',
							'Veículo': row.veiculo.veiculo_placa,
							'Profissional': row.profissional.profissional_nome,
              'Tipo Profissional': row.tipo_profissional_nome,
							'Inicio do turno': row.embarque_equipe_registro? moment(row.embarque_equipe_registro).format('DD/MM/YYYY HH:mm:ss') : '',
              'Fim do turno': row.embarque_equipe_fim_turno? moment(row.embarque_equipe_fim_turno).format('DD/MM/YYYY HH:mm:ss') : '',
						};

						++index;
						ultimoId = row.embarque_equipe_id;
					}

					localFunction(ultimoId);
				}
				else {
					this.excelSvc.exportAsExcelFile(data, 'Chronos Frota - Embarque equipe');
					this.loading = false;
				}
			});
		};

		localFunction(-1);     

  }


  expandPanel() {
    this.showFilter = this.showFilter == true ? false : true;
  }

  print(id) {
    let url = location.href.split('#')[0] + '#' + '(print:print/checkmilimetragem/' + id + ')'
    window.open(url);
  }

  deletado(flag) {
    return flag == 'S' ? 'deletado' : '';
  }

  fechaTurno(id){
    this.embarqueEquipeSvc.fechaTurno(id).then((data:any) => {
      Swal.fire({
        type:"success",
        title: 'Turno fechado com sucesso!',
        onClose: ()=>{
          this.getConsultaPorRegiaoOuUsuario();
        }
      });
    }).catch((err) =>{
      Swal.fire({
        type:"error",
        title: 'Ops! Algo de errado aconteceu!',
        text: 'Tente novamente mais tarde.'
      });
    });
  }

  pegaProfissionaisClienteUnidade(e){
    this.loading = true;
    
    this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
			this.profissionais = data;

      this.loading = false;
		}).catch((err) => {
			console.log(err);
		});
  } 

       
  EditEmbarqueequipe(embarque_equipe_id){

    this.filtro = this.formFiltro.value;

    let params = '';

    for (let f in this.filtro) {
      let val = this.filtro[f];
      if (val) {
        let aux = f.split('___');
        if (aux[1] == 'data_i' || aux[1] == 'data_f')
          val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

        params += (params == '')? '?' : '&';
        params += f + "=" + val;
      }
    }

    this.router.navigate(['home/embarqueequipe/edit/' + embarque_equipe_id + params]);
  }


  VerEmbarqueequipe(embarque_equipe_id){

    this.filtro = this.formFiltro.value;

    let params = '';

    for (let f in this.filtro) {
      let val = this.filtro[f];
      if (val) {
        let aux = f.split('___');
        if (aux[1] == 'data_i' || aux[1] == 'data_f')
          val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD');

        params += (params == '')? '?' : '&';
        params += f + "=" + val;
      }
    }

    //Envia dados
    this.router.navigate(['home/embarqueequipe/edit/' + embarque_equipe_id + params + "/ver"] );
  }

  getConsultaPorRegiaoOuUsuario(){


		this.perfilUsuarioSvc.getByUsuarioPerfil(this.usuario_perfil).then((data: any) => {

			this.usuario_exibir_regiao = data.usuario_exibir_regiao
			if(this.usuario_exibir_regiao == "A"){
				this.pegaChecklistsRegiao();
			}else{
				this.pegaChecklists();
			}

		}).catch((err) => {
		console.log(err);scrollBy
		}); 


  }


}
